import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';
import './ExecutionProfileTab.css';

export default function ExecutionProfileTab({
  userData,
  userName,
  onLogout,
}) {
  const { t } = useTranslation('execution');
  const initials = (userName || '')
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?';

  return (
    <div className="execution-content execution-profile-tab">
      <h2>{t('myProfile')}</h2>
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">{initials}</div>
          <div className="profile-info">
            <h3>{userName || t('na')}</h3>
            <p className="profile-role">{t('executionStaff')}</p>
          </div>
        </div>
        <div className="profile-details">
          <div className="detail-row">
            <span className="detail-label">{t('email')}</span>
            <span className="detail-value">{userData?.email || t('na')}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('badgeId')}</span>
            <span className="detail-value">{userData?.badge_id || t('na')}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('department')}</span>
            <span className="detail-value">
              {userData?.primary_department_id || t('na')}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">{t('status')}</span>
            <span className={`detail-value status-${userData?.status || ''}`}>
              {userData?.status || t('na')}
            </span>
          </div>
          <div className="detail-row detail-row-language">
            <span className="detail-label">{t('language', 'Limba')}</span>
            <span className="detail-value detail-value-language">
              <LanguageSwitcher />
            </span>
          </div>
        </div>
      </div>
      <div className="execution-profile-actions">
        <button type="button" className="btn btn-primary logout-btn" onClick={onLogout}>
          {t('logout', 'Logout')}
        </button>
      </div>
    </div>
  );
}
